import React, { useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import withLayout from "../../../common/layout";
import { Container } from "../../../common/layout/styels";
import { RowContainer } from "../../../../styles/containers/styles";
import moment from "moment";
import { AddButton, AvailabilitiesSchedule, ButtonContainer, CalendarTable, Schedule, SchedulesBox } from "./style";
import { useDispatch, useSelector } from "react-redux";
import { GetIcon } from "../../../../../icons";
import { addPageObject } from "../../../../../store/actions/pages";
import {} from "../../attendance/schedules/styles";
import { timeFormat } from "../../../../functions/date";
import PopupView from "../../../../elements/popupview";
import { DisplayInformations } from "../../../../elements/list/popup";
import { postData, putData } from "../../../../../backend/api";
import AutoForm from "../../../../elements/form";
import { CenterBox } from "../../attendance/worklog/styles";
import { BlankButton } from "../../attendance/styels";
import { useNavigate } from "react-router-dom";

const Schedules = ({setLoaderBox, setMessage,}) => {
  const me = useSelector((state) => state.login)
  const [currentApi] = useState(`user/schedules`);
  const [t, i18n] = useTranslation();
  const [currentDate, setCurrentDate] = useState(moment().startOf("month"));
  const [calendar, setCalendar] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const themeColors = useSelector((state) => state.themeColors);
  useEffect(() => {
    document.title = `${t("attendance")} - PersoBase`;
  }, [t]);
  const selectedLanguage = i18n.language || "de";
  const daysInMonth = currentDate.daysInMonth();
  const firstDayOfMonth = currentDate.startOf("month").day();
  const [loadedData, setLoadedData] = useState([]);
  const [initialized] = useState(true);
  const [addAtrributes, setAddAttributes] = useState([]);
  const [condition] = useState({ item: "reccuring", if: true, then: "enabled", else: "disabled" });
  const [shiftCondition] = useState({ item: "shift", if: "", else: "enabled", then: "disabled" });
  const [isOpenSchedule, setIsOpenSchedule] = useState(false);
  const [isAddAvailability, setIsAddAvailability] = useState(false);
  const [openSchedule, setOpenSchedule] = useState({});
  const [openScheduleType, setOpenScheduleType] = useState("");
  const [saveApiUrl, setSaveApiUrl] = useState("");
  const [modifySchedule, setModifySchedule] = useState(false);
  //Loading Data
  const users = useSelector((state) =>
    state.pages[`${currentApi}`]
      ? state.pages[`${currentApi}`]
      : {
          data: null,
          isLoading: true,
          error: null,
        }
  );
  useEffect(() => {
    if (initialized) {
      dispatch(addPageObject(currentApi, 0, 0));
    }
  }, [initialized, currentApi, dispatch]);
  // const [draggedDates, setDraggedDates] = useState([]);
  useEffect(() => {
    setLoadedData(users);
  }, [users]);
  const daysOrder =
  selectedLanguage === "de"
    ? ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
    : ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

// Memoize the generateCalendar function with useCallback
const generateCalendar = useCallback(() => {
  const calendarTemp = [];
  let day = 1;

  // Adjust blankDays to start from Monday
  let blankDays = (firstDayOfMonth === 0 ? 6 : firstDayOfMonth - 1); // Adjust first day (0=Sun becomes 6, others shift back by 1)
  let week = [];

  while (day <= daysInMonth) {
    if (blankDays > 0) {
      week.push(null); // Add blank days
      blankDays--;
    } else {
      week.push(currentDate.clone().date(day)); // Add actual days
      day++;
    }

    if (week.length === 7 || day > daysInMonth) {
      calendarTemp.push(week); // Push completed week
      week = [];
    }
  }

  // Fill the last week with nulls to complete it if necessary
  const lastWeekDays = 7 - calendarTemp[calendarTemp.length - 1].length;
  if (lastWeekDays > 0) {
    for (let i = 0; i < lastWeekDays; i++) {
      calendarTemp[calendarTemp.length - 1].push(null);
    }
  }

  setCalendar(calendarTemp);
}, [currentDate, daysInMonth, firstDayOfMonth]);


  useEffect(() => {
    generateCalendar();
  }, [generateCalendar]);

  const handlePrevMonth = () => {
    const prevMonth = currentDate.clone().subtract(1, "month");
    setCurrentDate(prevMonth);
    dispatch(addPageObject(currentApi, 0, 0, { date: prevMonth.toDate() }));
  };

  const handleNextMonth = () => {
    const nextMonth = currentDate.clone().add(1, "month");
    setCurrentDate(nextMonth);
    dispatch(addPageObject(currentApi, 0, 0, { date: nextMonth.toDate() }));
  };

  const renderCalendarHeader = () => (
    <tr>
      {daysOrder.map((day) => (
        <th className={`${day === "Sun" ? "sun":""}`} key={day}>{t(day)}</th>
      ))}
    </tr>
  );
  
  const handleSchedule = (schedule,day) => {
    let date = moment(day);
    setOpenSchedule(schedule)
    setOpenScheduleType("schedule");
    setAddAttributes([
      {
        type: "select",
        placeholder: "shift",
        name: "shiftTemplate",
        validation: "",
        updateCondition: [
          { item: "startTime", value: "shiftStart" },
          { item: "endTime", value: "shiftEnd" },
          { item: "break", value: "break" },
        ],
        tags: [
          { type: "time", item: "shiftStart", title: "shiftStart", collection: "" },
          { type: "time", item: "shiftEnd", title: "shiftEnd", collection: "" },
        ],
        default: "",
        label: "shift",
        showItem: "title",
        required: true,
        view: true,
        add: false,
        update: false,
        apiType: "API",
        selectApi: "shift/select",
        customClass: "half",
      },
      // {
      //   type: "select",
      //   placeholder: "place",
      //   name: "place",
      //   validation: "",
      //   condition: shiftCondition,
      //   default: "",
      //   label: "place",
      //   showItem: "title",
      //   required: true,
      //   view: true,
      //   add: false,
      //   update: false,
      //   apiType: "API",
      //   selectApi: "place/select",
      //   customClass: "half",
      // },
      {
        type: "date",
        placeholder: "scheduleDate",
        condition: shiftCondition,
        name: "startTime",
        validation: "",
        maxDate: date.clone().add(3, "months"),
        default: date.clone().startOf("day"),
        label: "scheduleDate",
        required: true,
        view: true,
        add: false,
        update: false,
      },
      {
        type: "time",
        placeholder: "startTime",
        condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
        name: "startTime",
        validation: "",
        default: schedule.startTime,
        label: "startTime",
        required: true,
        interval: 15,
        view: true,
        add: true,
        update: true,
      },
      {
        type: "time",
        placeholder: "endTime",
        name: "endTime",
        condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
        validation: "",
        default: schedule.endTime,
        label: "endTime",
        required: true,
        interval: 15,
        view: true,
        add: true,
        update: true,
      },
      // {
      //   type: "number",
      //   placeholder: "startBuffer",
      //   condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
      //   name: "startBuffer",
      //   validation: "",
      //   default: schedule.startBuffer,
      //   showItem: "value",
      //   label: "startBuffer",
      //   required: true,
      //   view: true,
      //   add: true,
      //   update: true,
      //   customClass: "half",
      //   filter: false,
      //   apiType: "JSON",
      //   selectApi: [
      //     { value: "10 minutes", id: 10 },
      //     { value: "15 minutes", id: 15 },
      //     { value: "20 minutes", id: 20 },
      //     { value: "25 minutes", id: 25 },
      //     { value: "30 minutes", id: 30 },
      //     { value: "45 minutes", id: 45 },
      //     { value: "60 minutes", id: 60 },
      //   ],
      // },
      // {
      //   type: "number",
      //   placeholder: "endBuffer",
      //   condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
      //   name: "endBuffer",
      //   validation: "",
      //   default: schedule.endBuffer,
      //   showItem: "value",
      //   label: "endBuffer",
      //   required: true,
      //   view: true,
      //   add: true,
      //   update: true,
      //   customClass: "half",
      //   filter: false,
      //   apiType: "JSON",
      //   selectApi: [
      //     { value: "10 minutes", id: 10 },
      //     { value: "15 minutes", id: 15 },
      //     { value: "20 minutes", id: 20 },
      //     { value: "25 minutes", id: 25 },
      //     { value: "30 minutes", id: 30 },
      //     { value: "45 minutes", id: 45 },
      //     { value: "60 minutes", id: 60 },
      //   ],
      // },
      // {
      //   type: "number",
      //   condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
      //   placeholder: "break",
      //   name: "break",
      //   validation: "",
      //   default: schedule.break,
      //   label: "break",
      //   required: true,
      //   minimum: 0,
      //   maximum: 60,
      //   view: true,
      //   add: true,
      //   update: true,
      // },
      
    ]);
    setIsOpenSchedule(true);
  }
  const applyOpenService = (schedule,day) => {
    let date = moment(day);
    setOpenSchedule(schedule)
    setOpenScheduleType("openServices");
    setAddAttributes([
      {
        type: "select",
        placeholder: "shift",
        name: "shiftDetails",
        validation: "",
        updateCondition: [
          { item: "startTime", value: "shiftStart" },
          { item: "endTime", value: "shiftEnd" },
          { item: "break", value: "break" },
        ],
        tags: [
          { type: "time", item: "shiftStart", title: "shiftStart", collection: "" },
          { type: "time", item: "shiftEnd", title: "shiftEnd", collection: "" },
        ],
        default: "",
        label: "shift",
        showItem: "shortForm",
        required: true,
        view: true,
        add: false,
        update: false,
        apiType: "API",
        selectApi: "shift/select",
        customClass: "half",
      },
      {
        type: "select",
        placeholder: "place",
        name: "place",
        validation: "",
        condition: shiftCondition,
        default: "",
        label: "place",
        showItem: "title",
        required: true,
        view: true,
        add: false,
        update: false,
        apiType: "API",
        selectApi: "place/select",
        customClass: "half",
      },
      {
        type: "date",
        placeholder: "scheduleDate",
        condition: shiftCondition,
        name: "startTime",
        validation: "",
        maxDate: date.clone().add(3, "months"),
        default: date.clone().startOf("day"),
        label: "scheduleDate",
        required: true,
        view: true,
        add: false,
        update: false,
      },
      {
        type: "time",
        placeholder: "startTime",
        condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
        name: "startTime",
        validation: "",
        default: schedule.startTime,
        label: "startTime",
        required: true,
        interval: 15,
        view: true,
        add: false,
        update: false,
      },
      {
        type: "time",
        placeholder: "endTime",
        name: "endTime",
        condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
        validation: "",
        default: schedule.endTime,
        label: "endTime",
        required: true,
        interval: 15,
        view: true,
        add: false,
        update: false,
      },
      // {
      //   type: "number",
      //   placeholder: "startBuffer",
      //   condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
      //   name: "startBuffer",
      //   validation: "",
      //   default: schedule.startBuffer,
      //   showItem: "value",
      //   label: "startBuffer",
      //   required: true,
      //   view: true,
      //   add: false,
      //   update: false,
      //   customClass: "half",
      //   filter: false,
      //   apiType: "JSON",
      //   selectApi: [
      //     { value: "10 minutes", id: 10 },
      //     { value: "15 minutes", id: 15 },
      //     { value: "20 minutes", id: 20 },
      //     { value: "25 minutes", id: 25 },
      //     { value: "30 minutes", id: 30 },
      //     { value: "45 minutes", id: 45 },
      //     { value: "60 minutes", id: 60 },
      //   ],
      // },
      // {
      //   type: "number",
      //   placeholder: "endBuffer",
      //   condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
      //   name: "endBuffer",
      //   validation: "",
      //   default: schedule.endBuffer,
      //   showItem: "value",
      //   label: "endBuffer",
      //   required: true,
      //   view: true,
      //   add: false,
      //   update: false,
      //   customClass: "half",
      //   filter: false,
      //   apiType: "JSON",
      //   selectApi: [
      //     { value: "10 minutes", id: 10 },
      //     { value: "15 minutes", id: 15 },
      //     { value: "20 minutes", id: 20 },
      //     { value: "25 minutes", id: 25 },
      //     { value: "30 minutes", id: 30 },
      //     { value: "45 minutes", id: 45 },
      //     { value: "60 minutes", id: 60 },
      //   ],
      // },
      {
        type: "number",
        condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
        placeholder: "break",
        name: "break",
        validation: "",
        default: schedule.break,
        label: "break",
        required: true,
        minimum: 0,
        maximum: 60,
        view: true,
        add: false,
        update: false,
      },
      // {
      //   type: "number",
      //   placeholder: "Required Employee",
      //   name: "serviceCount",
      //   condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
      //   validation: "",
      //   default: "",
      //   showItem: "value",
      //   label: "Required Employee",
      //   required: true,
      //   view: true,
      //   add: false,
      //   update: false,
      // },
      {
        type: "textarea",
        placeholder: "note",
        name: "title",
        validation: "",
        condition: shiftCondition,
        default: "",
        label: "note",
        required: false,
        view: true,
        add: false,
        update: false,
      },
      {
        type: "text",
        placeholder: "status",
        name: "userApplicationStatus",
        validation: "",
        label: "status",
        showItem: "status",
        view: true,
        add: false,
        update: false,
      },
      // {
      //   type: "info",
      //   condition: { item: "isDeleted", if: false, then: "enabled", else: "disabled" },
      //   name: "userApplicationStatus",
      //   validation: "",
      //   content: "Check below to delete this schedule",
      //   label: "status",
      //   showItem: "status",
      //   view: true,
      //   add: false,
      //   update: false,
      // },
      // {
      //   type: "info",
      //   condition: { item: "isDeleted", if: true, then: "enabled", else: "disabled" },
      //   name: "deleteSchedule",
      //   validation: "",
      //   content: "deleteWarning",
      //   label: "deleteSchedule",
      //   view: true,
      //   add: false,
      //   update: false,
      // },
      // {
      //   type: "checkbox",
      //   placeholder: "delete",
      //   name: "isDeleted",
      //   validation: "",
      //   default: false,
      //   label: "delete",
      //   required: true,
      //   minimum: 0,
      //   maximum: 60,
      //   view: true,
      //   add: false,
      //   update: false,
      // },
      // {
      //   type: "info",
      //   condition: { item: "deleteAll", if: true, then: "enabled", else: "disabled" },
      //   name: "deleteSchedule",
      //   validation: "",
      //   content: "deleteAllWarning",
      //   label: "deleteSchedule",
      //   view: true,
      //   add: false,
      //   update: false,
      // },
      // {
      //   type: "checkbox",
      //   placeholder: "deleteAll",
      //   name: "deleteAll",
      //   validation: "",
      //   condition: { item: "isDeleted", if: true, then: "enabled", else: "disabled" },
      //   default: false,
      //   label: "deleteAll",
      //   required: true,
      //   minimum: 0,
      //   maximum: 60,
      //   view: true,
      //   add: false,
      //   update: false,
      // },
    ]);
    setIsOpenSchedule(true);
  }

  const addNewAvailabilty = (day) => {
    let date = moment(day??new Date());
    setSaveApiUrl("availability")
    setAddAttributes([
      {
        type: "date",
        placeholder: "scheduleDate",
        name: "startDate",
        validation: "",
        maxDate: date.clone().add(3, "months"),
        default: date.clone().startOf("day").add(7, "hours"),
        label: "scheduleDate",
        required: true,
        view: true,
        add: true,
        update: true,
      },
      {
        type: "select",
        placeholder: "availability",
        name: "availableType",
        validation: "",
        default: "",
        showItem: "value",
        label: "availability",
        required: true,
        view: true,
        add: true,
        update: true,
        customClass: "half",
        filter: false,
        apiType: "JSON",
        selectApi: [
          { value: "full-day", id: "full-day" },
          { value: "available-from", id: "available-from" },
          { value: "not-full-day", id: "not-full-day" },
          // { value: "not-available-from", id: "not-available-from" }
        ],
      },
      {
        type: "time",
        placeholder: "startTime",
        condition: { item: "availableType", if: "available-from", then: "enabled", else: "disabled" },
        name: "startTime",
        validation: "",
        default: "",
        label: "startTime",
        required: true,
        interval: 15,
        view: true,
        add: true,
        update: true,
      },
      {
        type: "time",
        placeholder: "endTime",
        condition: { item: "availableType", if: "available-from", then: "enabled", else: "disabled" },
        name: "endTime",
        validation: "",
        default: "",
        label: "endTime",
        required: true,
        interval: 15,
        view: true,
        add: true,
        update: true,
      },
      {
        type: "textarea",
        placeholder: "reason",
        name: "reason",
        validation: "",
        condition: shiftCondition,
        default: "",
        label: "reason",
        required: false,
        view: true,
        add: true,
        update: true,
      },
      {
        type: "info",
        placeholder: "days",
        name: "days",
        validation: "",
        default: false,
        label: "days",
        required: true,
        minimum: 0,
        maximum: 60,
        view: true,
        add: true,
        update: true,
      },

      {
        type: "checkbox",
        placeholder: "reccuring",
        condition: shiftCondition,
        name: "reccuring",
        validation: "",
        default: false,
        label: "reccuring",
        required: true,
        minimum: 0,
        maximum: 60,
        view: true,
        add: true,
        update: true,
      },

      {
        type: "info",
        placeholder: "days",
        name: "days",
        content: "selectDays",
        validation: "",
        condition: condition,
        default: false,
        label: "days",
        required: true,
        minimum: 0,
        maximum: 60,
        view: true,
        add: true,
        update: true,
      },
      {
        type: "multiSelect",
        placeholder: "eligibleDays",
        name: "eligibleDays",
        listView: true,
        validation: "",
        default: "",
        label: "eligibleDays",
        required: true,
        view: true,
        condition: condition,
        customClass: "half",
        add: true,
        update: true,
        apiType: "JSON",
        selectApi: [
          { value: t("Monday"), id: "monday" },
          { value: t("Tuesday"), id: "tuesday" },
          { value: t("Wednesday"), id: "wednesday" },
          { value: t("Thursday"), id: "thursday" },
          { value: t("Friday"), id: "friday" },
          { value: t("Saturday"), id: "saturday" },
          { value: t("Sunday"), id: "sunday" },
        ],
      },
      {
        type: "date",
        placeholder: "scheduleEnd",
        name: "endDate",
        validation: "",
        customClass: "half",
        condition: condition,
        greater: "startDate",
        minDate: date.clone().add(1, "days"),
        maxDate: date.clone().add(3, "months"),
        default: date.clone().startOf("day").add(15, "hours"),
        label: "scheduleEnd",
        required: true,
        view: true,
        add: true,
        update: true,
      },
      
    ]);
    setIsAddAvailability(true);
  }
  const updateAvailabilty = (day,schedule) => {
    let date = moment(day??new Date());
    setSaveApiUrl(`availability/${schedule._id}`)
    setOpenSchedule(schedule)
    setAddAttributes([
      {
        type: "date",
        placeholder: "scheduleDate",
        name: "startDate",
        validation: "",
        maxDate: date.clone().add(3, "months"),
        default: date.clone().startOf("day").add(7, "hours"),
        label: "scheduleDate",
        required: true,
        view: true,
        add: true,
        update: true,
      },
      {
        type: "select",
        placeholder: "availability",
        name: "availableType",
        validation: "",
        default: schedule.availableType,
        label: "availability",
        showItem:"value",
        required: true,
        view: true,
        add: true,
        update: true,
        customClass: "half",
        filter: false,
        apiType: "JSON",
        selectApi: [
          { value: "full-day", id: "full-day" },
          { value: "available-from", id: "available-from" },
          { value: "not-full-day", id: "not-full-day" },
          // { value: "not-available-from", id: "not-available-from" }
        ],
      },
      {
        type: "time",
        placeholder: "startTime",
        condition: { item: "availableType", if: "available-from", then: "enabled", else: "disabled" },
        name: "startTime",
        validation: "",
        default: schedule.startTime,
        label: "startTime",
        required: true,
        interval: 15,
        view: true,
        add: true,
        update: true,
      },
      {
        type: "time",
        placeholder: "endTime",
        condition: { item: "availableType", if: "available-from", then: "enabled", else: "disabled" },
        name: "endTime",
        validation: "",
        default: schedule.endTime,
        label: "endTime",
        required: true,
        interval: 15,
        view: true,
        add: true,
        update: true,
      },
      {
        type: "textarea",
        placeholder: "reason",
        name: "reason",
        validation: schedule.reason,
        condition: shiftCondition,
        default: "",
        label: "reason",
        required: false,
        view: true,
        add: true,
        update: true,
      },
      // {
      //   type: "info",
      //   placeholder: "days",
      //   name: "days",
      //   validation: "",
      //   default: false,
      //   label: "days",
      //   required: true,
      //   minimum: 0,
      //   maximum: 60,
      //   view: true,
      //   add: true,
      //   update: true,
      // },

      // {
      //   type: "checkbox",
      //   placeholder: "reccuring",
      //   condition: shiftCondition,
      //   name: "reccuring",
      //   validation: "",
      //   default: false,
      //   label: "reccuring",
      //   required: true,
      //   minimum: 0,
      //   maximum: 60,
      //   view: true,
      //   add: true,
      //   update: true,
      // },

      // {
      //   type: "info",
      //   placeholder: "days",
      //   name: "days",
      //   content: "selectDays",
      //   validation: "",
      //   condition: condition,
      //   default: false,
      //   label: "days",
      //   required: true,
      //   minimum: 0,
      //   maximum: 60,
      //   view: true,
      //   add: true,
      //   update: true,
      // },
      // {
      //   type: "multiSelect",
      //   placeholder: "eligibleDays",
      //   name: "eligibleDays",
      //   listView: true,
      //   validation: "",
      //   default: "",
      //   label: "eligibleDays",
      //   required: true,
      //   view: true,
      //   condition: condition,
      //   customClass: "half",
      //   add: true,
      //   update: true,
      //   apiType: "JSON",
      //   selectApi: [
      //     { value: t("Monday"), id: "monday" },
      //     { value: t("Tuesday"), id: "tuesday" },
      //     { value: t("Wednesday"), id: "wednesday" },
      //     { value: t("Thursday"), id: "thursday" },
      //     { value: t("Friday"), id: "friday" },
      //     { value: t("Saturday"), id: "saturday" },
      //     { value: t("Sunday"), id: "sunday" },
      //   ],
      // },
      // {
      //   type: "date",
      //   placeholder: "scheduleEnd",
      //   name: "endDate",
      //   validation: "",
      //   customClass: "half",
      //   condition: condition,
      //   greater: "startDate",
      //   minDate: date.clone().add(1, "days"),
      //   maxDate: date.clone().add(3, "months"),
      //   default: date.clone().startOf("day").add(15, "hours"),
      //   label: "scheduleEnd",
      //   required: true,
      //   view: true,
      //   add: true,
      //   update: true,
      // },
      
    ]);
    setModifySchedule(true);
  }

  const actionFunction = ()=>{
    setLoaderBox(true);
    postData({id:openSchedule._id}, `user/appliedToOpenService`, dispatch, navigate)
      .then((response) => {
        if (response.status === 200) {
          setMessage({ type: 1, content: t(response.data.message), proceed: "Okay", code: 200 });
          let loadedDataTemp = {...loadedData};
          let index = loadedDataTemp?.data?.openService?.findIndex((service) => service._id === openSchedule._id)
          if(index>=0)
            loadedDataTemp.data.openService[index] = response.data?.data;
          setLoadedData(loadedDataTemp);
          setIsOpenSchedule(false);
        } else if (response.status === 404) {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 404 });
        } else {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 500 });
        }
        setLoaderBox(false);
      })
      .catch((error) => {
        setMessage({ type: 1, content: error.message + "Something went wrong!", proceed: "Okay", code: 500 });
        setLoaderBox(false);
      });
  }

  const submitHandler = async (data) => {
    setLoaderBox(true);
    await postData(data, saveApiUrl, dispatch, navigate)
      .then((response) => {
        if (response.status === 200) {
          setMessage({ type: 1, content: t(response.data.message), proceed: "Okay", code: 200 });
          // refreshView(currentIndex);
          setIsAddAvailability(false);
        } else if (response.status === 404) {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 404 });
        } else {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 500 });
        }
        setLoaderBox(false);
      })
      .catch((error) => {
        alert(error);
        setLoaderBox(false);
      });
  
  };

  const updateHandler = async (data) => {
    setLoaderBox(true);

    await putData(data, saveApiUrl, dispatch, navigate)
      .then((response) => {
        if (response.status === 200) {
          setMessage({ type: 1, content: t(response.data.message), proceed: "Okay", code: 200 }); 
          // refreshView(currentIndex);
          setModifySchedule(false);
        } else if (response.status === 404) {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 404 });
        } else {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 500 });
        }
        setLoaderBox(false);
      })
      .catch((error) => {
        alert(error);
        setLoaderBox(false);
      });
  };


  return (
    <Container className="noshadow">
      <RowContainer className="custom">
        <ButtonContainer theme={themeColors}>
          <button onClick={handlePrevMonth}>
            <GetIcon icon={"previous"}></GetIcon>
            {t("Previous Month")}
          </button>
          <button onClick={handleNextMonth}>
            {t("Next Month")}
            <GetIcon icon={"next"}></GetIcon>
          </button>
        </ButtonContainer>
        <CalendarTable theme={themeColors}>
          <thead>
            <tr>
              <th colSpan="7">{`${t(`month-${currentDate.format("M")}`)} ${currentDate.format("YYYY")}`}</th>
            </tr>
            {renderCalendarHeader()}
          </thead>
          <tbody>
            {calendar.map((week, weekIndex) => (
              <tr key={weekIndex}>
                {week.map((day, dayIndex) => (
                  <td className={day ? "enable" : "disabled"} key={dayIndex} >
                    {day ? (
                      <>
                        <span className={`dayNumber ${day.clone().format("d") === "0" ? "sun":""}`}>{day.clone().format("D")}</span>
                        <SchedulesBox style={{paddingTop: window.innerWidth > 768 ? "" : "25px"}} key={dayIndex} className={loadedData.data?.availabilities?.length>0 ? "availability":""}
                          onClick={(e) => {
                            console.log(e.target.classList);
                            // Check if the click happened on the data area
                            if (!e.target.classList.contains("data-box")) {
                              addNewAvailabilty(day); 
                            }
                          }}
                          >
                          {/* Render Availability */}
                          {loadedData?.data?.availabilities?.length>0 ? (loadedData.data?.availabilities?.filter((item) => moment(item.startTime).format("D") === day.clone().format("D")).sort((a, b) => moment(a.startTime).isBefore(moment(b.startTime)) ? -1 : 1).map((schedule, scheduleIndex) => {
                              return (
                                <AvailabilitiesSchedule
                                onClick={()=> updateAvailabilty(day,schedule)}
                                  key={schedule._id}
                                  value={schedule._id}
                                  style={{
                                    backgroundColor: (schedule.availableType==="not-full-day" || schedule.availableType==="not-available-from" ) ?"#FF0000":"#9ee0bb",
                                  }}
                                  className="data-box"
                                  >
                                  {schedule.availableType==="available-from" ? window.innerWidth > 768 ? <span className="available-from data-box">
                                    {`${timeFormat(schedule.startTime)} - ${timeFormat(schedule.endTime)} ${window.innerWidth > 768 ? schedule?.reason:""}`}
                                  </span> : <>
                                    <div className="data-box">{`${timeFormat(schedule.startTime)}`}</div>
                                    <div className="data-box">{`${timeFormat(schedule.endTime)}`}</div>
                                  </>
                                  : <span className="available-from data-box">
                                  {t(`type-${schedule.availableType}`)}
                                </span>
                                  }
                                </AvailabilitiesSchedule>
                              );
                            })) : (
                              <CenterBox>
                                <BlankButton
                                  onClick={() => {
                                    // addNewOpenServiceSchedule(entry, value);
                                  }}
                                >
                                  <GetIcon icon="add" />
                                </BlankButton>
                              </CenterBox>
                            )}

                          {loadedData.data?.schedules?.length>0 ? ( loadedData.data?.schedules
                            ?.filter((item) => moment(item.startTime).format("D") === day.clone().format("D"))
                            .sort((a, b) => moment(a.startTime).isBefore(moment(b.startTime)) ? -1 : 1)
                            .map((schedule, index) => (
                              <Schedule style={{marginTop: (loadedData.data?.availabilities?.filter((item) => moment(item.startTime).format("D") === day.clone().format("D"))?.length>0 && window.innerWidth > 768 && index===0) ? '13px':'0'}} onClick={()=> handleSchedule(schedule,day)} key={index} color={schedule.shiftTemplate?.color ?? "black"}
                              className="data-box"
                              >
                                {window.innerWidth > 768 && <span className="data-box">{schedule.shiftTemplate?.shortForm ? schedule.shiftTemplate?.shortForm + " " + schedule.shiftTemplate?.title : schedule.title}</span>}
                                {window.innerWidth > 768 ? <span className="data-box">{`${timeFormat(schedule.startTime)} - ${timeFormat(schedule.endTime)}`}</span> : <>
                                  <span className="data-box">{`${timeFormat(schedule.startTime)}`}</span>
                                  <span className="data-box">{`${timeFormat(schedule.endTime)}`}</span>
                                </>}
                              </Schedule>
                            ))) : (
                              <CenterBox>
                                <BlankButton
                                  onClick={() => {
                                    // addNewOpenServiceSchedule(entry, value);
                                  }}
                                >
                                  <GetIcon icon="add" />
                                </BlankButton>
                              </CenterBox>
                            )}
                          {loadedData.data?.openService?.length > 0 ? (loadedData.data?.openService
                            ?.filter((item) => moment(item.startTime).format("D") === day.clone().format("D"))
                            .sort((a, b) => moment(a.startTime).isBefore(moment(b.startTime)) ? -1 : 1)
                            .map((schedule, index) => (
                              <Schedule key={index} value={schedule._id}
                              className="data-box"
                              onClick={()=> applyOpenService(schedule,day)}
                              title={t("This is open shift")}
                              style={{
                                backgroundColor: "#3E4095",
                                // marginTop: window.innerWidth > 768 ? "auto" : "0px"
                              }}>
                                {window.innerWidth > 768 && <span className="data-box" style={{color:'white',opacity:1,display:'flex', justifyContent:'space-between',alignItems:'center',width:'100%'}}>{schedule.shiftDetails?.shortForm ? (schedule?.shiftDetails && schedule.shiftDetails?.shortForm) : (schedule?.shiftDetails && schedule.shiftDetails?.title)}
                                  <span className="data-box" style={{color: schedule?.userApplicationStatus?.status==="confirmed" ? "#27e37a" : schedule?.userApplicationStatus?.status==="pending" ? "orange" : "#e06666", backgroundColor:'transparent'}}>
                                    {t(schedule?.userApplicationStatus?.status)}
                                  </span>
                                  </span>}
                                  {window.innerWidth > 768 ? <span className="data-box" style={{color:'white',opacity:1}}>
                                    {`${timeFormat(schedule.startTime)} - ${timeFormat(schedule.endTime)} `}
                                    {/* {schedule.updated && <GetIcon icon={"edited"}></GetIcon>} */}
                                  </span> : <>
                                    <span className="data-box" style={{color:'white',opacity:1}}>{`${timeFormat(schedule.startTime)}`}</span>
                                    <span className="data-box" style={{color:'white',opacity:1}}>{`${timeFormat(schedule.endTime)}`}</span>
                                </>}
                              </Schedule>
                            ))): (
                              <CenterBox>
                                <BlankButton
                                  onClick={() => {
                                    // addNewOpenServiceSchedule(entry, value);
                                  }}
                                >
                                  <GetIcon icon="add" />
                                </BlankButton>
                              </CenterBox>
                            )}
                          {loadedData.data?.absense?.length > 0 ? (loadedData.data?.absense
                            ?.filter((item) => moment(item.date).format("D") === day.clone().format("D"))
                            .map((absense, index) => (
                              <Schedule key={index} color={absense.approval==="Confirmed" ? "#27e37a" : absense.approval==="Pending" ? "orange" : "red"} className="data-box">
                                <span className="data-box">{absense.leaveType?.[selectedLanguage]}</span>
                                <span className="data-box">{window.innerWidth > 768 ? absense.note : (absense?.note?.length > 10 ? (absense.note.slice(0,10)+"...") : absense.note)}</span>
                              </Schedule>
                            ))): (
                              <CenterBox>
                                <BlankButton
                                  onClick={() => {
                                    // addNewOpenServiceSchedule(entry, value);
                                  }}
                                >
                                  <GetIcon icon="add" />
                                </BlankButton>
                              </CenterBox>
                            )}
                          {loadedData.data?.holidays[day.clone().format("YYYY-MM-DD")] ? (
                            <Schedule key={0} color={"red"} className="data-box">
                              <span className="data-box">{t("holiday")}</span>
                              {window.innerWidth > 768 && <span className="data-box">{loadedData.data?.holidays[day.clone().format("YYYY-MM-DD")]}</span>}
                            </Schedule>
                          ): (
                            <CenterBox>
                              <BlankButton
                                onClick={() => {
                                  // addNewOpenServiceSchedule(entry, value);
                                }}
                              >
                                <GetIcon icon="add" />
                              </BlankButton>
                            </CenterBox>
                          )}
                          {/* {loadedData.data?.workDays[day.clone().locale("en").format("ddd").toLowerCase()] === false && (
                            <Schedule key={0} color={"red"}>
                              <span>{t("holiday")}</span>
                              <span>{t("weekend")}</span>
                            </Schedule>
                          )} */}
                        </SchedulesBox>
                      </>
                    ) : // Render nothing for days without data
                    null}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </CalendarTable>
      </RowContainer>
      {isOpenSchedule && (
        <PopupView
          popupData={
            <DisplayInformations
              udpateView={false}
              isEditingHandler={false}
              actions={null}
              setMessage={setMessage}
              setLoaderBox={setLoaderBox}
              formMode={"double"}
              formView={"normal"}
              attributes={addAtrributes}
              data={openSchedule}
              api={"api"}
              tabName={openScheduleType}
            />
          }
          closeModal={() => {
            setIsOpenSchedule(false);
          }}
          setMessage={setMessage}
          setLoaderBox={setLoaderBox}
          profileImage={null}
          itemTitle={openScheduleType}
          openData={{ data: openSchedule }}
          customClass={"normal"}
          actionButton={openScheduleType === "openServices" ? (openSchedule?.userApplicationStatus?.status === "confirmed" || openSchedule?.userApplicationStatus?.status === "rejected" ? false : true) : false}
          actionFunction={actionFunction}
        ></PopupView>
      )}
      {isAddAvailability && (
        <AutoForm
          userId={me?.data?.user?._id}
          useCaptcha={false}
          useCheckbox={false}
          description={""}
          setMessage={setMessage}
          key={"type.description"}
          formType={"post"}
          header={t("addNewTitle", { label: t("addAvailability") })}
          formInput={addAtrributes}
          submitHandler={submitHandler}
          button={t("submit")}
          isOpenHandler={(value) => {
            setIsAddAvailability(value);
          }}
          isOpen={true}
          plainForm={false}
        ></AutoForm>
      )}
      {modifySchedule && (
        <AutoForm
          userId={me?.data?.user?._id}
          useCaptcha={false}
          useCheckbox={false}
          description={""}
          formValues={openSchedule}
          setMessage={setMessage}
          key={"type.description"}
          formType={"put"}
          header={t("update", { label: t("updateAvailability") })}
          formInput={addAtrributes}
          submitHandler={updateHandler}
          button={t("submit")}
          isOpenHandler={(value) => {
            setModifySchedule(value);
          }}
          isOpen={true}
          plainForm={false}
        ></AutoForm>
      )}
    </Container>
  );
};

export default withLayout(Schedules);
